// extracted by mini-css-extract-plugin
export default {"images":"Posts_images__s4qqS"};